"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyRecurrencePane = void 0;
var React = require("react");
var Recurrence_1 = require("../Recurrence");
var TimeHhMm_1 = require("../TimeHhMm");
var WeekDayPicker_1 = require("../controls/WeekDayPicker");
var StartTimeEndTimeComponent_1 = require("../StartTimeEndTimeComponent");
var TimeZoneDisplay_1 = require("../controls/TimeZoneDisplay");
var widgets_1 = require("@tableau/widgets");
var SelfServiceSchedulePane_1 = require("../SelfServiceSchedulePane");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var FlowRunPaneTypeStyles_1 = require("../../styles/FlowRunPaneTypeStyles");
var DayPickerStyle = { flex: '1 2 400px', marginTop: '18px' };
var StartTimePickerStyle = { flex: '1 2 165px', marginTop: '18px' };
var EndTimePickerStyle = { flex: '1 2 165px', marginTop: '18px', marginLeft: '24px' };
var EndTimePickerStyleHidden = { flex: '1 2 165px', marginTop: '18px', marginLeft: '24px', visibility: 'hidden' };
var TimeZoneStyle = { flex: '1 2 400px', marginTop: '18px' };
var Typography = widgets_1.TabStyles.Typography;
var BentonLabelTextStyle = {
    display: 'block',
    boxSizing: 'border-box',
    position: 'relative',
    fontSize: Typography.Sizing.Default,
    fontWeight: 'normal',
    color: Typography.Color.Primary,
    lineHeight: '21px'
};
var DailyRecurrencePane = /** @class */ (function (_super) {
    __extends(DailyRecurrencePane, _super);
    function DailyRecurrencePane(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.weekDaysChangedHandler = function (newDayChoiceIds) { return _this.onWeekDaysChange(newDayChoiceIds); };
        _this.startTimeChangeHandler = function (time) {
            var startTime = time.toNumber();
            var endTime = _this.props.recurrenceDetails.endTime;
            // New SSS backend requires super-hourly schedules to start and end on the same minute
            // Note that !this.props.type handles both the case in which type is unspecified
            // AND the case in which it is Default type as Default = 0
            if (!(_this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh)) {
                var endTimeHours = Math.floor(endTime / 60);
                var startTimeMinutes = startTime % 60;
                endTime = endTimeHours * 60 + startTimeMinutes;
                // If the "day" recurrence is selected we straight up want end time == start time
                if (_this.props.recurrenceDetails.recurrenceMinutes === Recurrence_1.RecurrenceMinutesToNumberMap.OneDay) {
                    endTime = startTime;
                }
            }
            // do not let endTime become less than start time by design for non Admin schedules
            if (_this.props.type !== SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule && endTime < startTime) {
                endTime = startTime;
            }
            var newDetails = __assign(__assign({}, _this.props.recurrenceDetails), { startTime: startTime, endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        };
        _this.endTimeChangeHandler = function (time) {
            var endTime = time.toNumber();
            var startTime = _this.props.recurrenceDetails.startTime;
            // New SSS backend requires super-hourly schedules to start and end on the same minute
            if (!(_this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh)) {
                var startTimeHours = Math.floor(startTime / 60);
                var endTimeMinutes = endTime % 60;
                startTime = startTimeHours * 60 + endTimeMinutes;
            }
            var newDetails = __assign(__assign({}, _this.props.recurrenceDetails), { startTime: startTime, endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        };
        _this.recurrenceMinutesChangeHandler = function (recurrenceMinutesId) {
            if (!(recurrenceMinutesId in Recurrence_1.RecurrenceMinutes)) {
                throw "Invalid reccurence minutes: " + recurrenceMinutesId;
            }
            var recurrenceMinutesKey = recurrenceMinutesId;
            var recurrenceMinutes = Recurrence_1.RecurrenceMinutesToNumberMap[recurrenceMinutesKey];
            var startTime = _this.props.recurrenceDetails.startTime;
            var endTime = _this.props.recurrenceDetails.endTime;
            var daysOfWeek = _this.props.recurrenceDetails.recurrenceDaysOfWeek;
            var isBridgeExtractRefresh = _this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh;
            var isOneDayRecurrence = recurrenceMinutes === Recurrence_1.RecurrenceMinutesToNumberMap.OneDay;
            if (!isBridgeExtractRefresh && isOneDayRecurrence) {
                endTime = startTime;
            }
            var newDetails = __assign(__assign({}, _this.props.recurrenceDetails), { recurrenceDaysOfWeek: daysOfWeek, recurrenceMinutes: recurrenceMinutes, startTime: startTime,
                endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        };
        _this.DailyRecurrenceOptionsDropDown = function () {
            return (React.createElement(widgets_1.SingleSelectDropdown, { label: Localize_1.Messages.RecurrenceCaptionEvery(), value: Recurrence_1.NumberToRecurrencesMinutesMap[_this.props.recurrenceDetails.recurrenceMinutes], testId: _this.props.testRecurrenceMinutesPickerId, onChange: _this.recurrenceMinutesChangeHandler, type: widgets_1.DropdownButtonType.Line, list: React.createElement(widgets_1.List, { items: _this.getDailyRecurrenceOptions(), style: { maxHeight: '300px', overflow: 'auto' } }), className: _this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.FlowRunTask ?
                    typestyle_1.style(FlowRunPaneTypeStyles_1.FlowRunPaneElementBaseStyle) :
                    typestyle_1.style({
                        flex: '1 2 165px',
                        marginTop: '18px',
                        marginBottom: '18px',
                        marginLeft: '24px',
                        margin: '18px, 0px, 0px, 24px'
                    }) }, Recurrence_1.localizeRecurrenceMinutes(Recurrence_1.NumberToRecurrencesMinutesMap[_this.props.recurrenceDetails.recurrenceMinutes])));
        };
        _this.weekDays = Recurrence_1.getWeekdayInfos();
        return _this;
    }
    DailyRecurrencePane.prototype.onWeekDaysChange = function (weekDayIds) {
        var newDetails = __assign(__assign({}, this.props.recurrenceDetails), { recurrenceDaysOfWeek: weekDayIds });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    DailyRecurrencePane.prototype.getDailyRecurrenceOptions = function () {
        return Recurrence_1.getDailyMinutesIntervalsForPaneType(this.props.type).map(function (minutes) { return ({
            value: minutes,
            content: Recurrence_1.localizeRecurrenceMinutes(minutes)
        }); });
    };
    DailyRecurrencePane.prototype.displayDaysOfWeekPicker = function () {
        return this.props.type !== SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminLegacySchedule;
    };
    DailyRecurrencePane.prototype.render = function () {
        var shouldOnlyShowAtField = this.props.recurrenceDetails.recurrenceMinutes === Recurrence_1.RecurrenceMinutesToNumberMap.OneDay;
        var isFlowRunTaskPaneType = this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.FlowRunTask;
        return (React.createElement(React.Fragment, null,
            React.createElement(this.DailyRecurrenceOptionsDropDown, null),
            React.createElement(StartTimeEndTimeComponent_1.StartTimeEndTimeComponent, { startCaption: shouldOnlyShowAtField
                    ? Localize_1.Messages.RecurrenceCaptionAt()
                    : Localize_1.Messages.RecurrenceCaptionFrom(), endCaption: Localize_1.Messages.RecurrenceCaptionTo(), selectedStartValue: TimeHhMm_1.TimeHhMm.fromNumber(this.props.recurrenceDetails.startTime), selectedEndValue: TimeHhMm_1.TimeHhMm.fromNumber(this.props.recurrenceDetails.endTime), onStartTimeChange: this.startTimeChangeHandler, onEndTimeChange: this.endTimeChangeHandler, startStyle: StartTimePickerStyle, endStyle: shouldOnlyShowAtField
                    ? EndTimePickerStyleHidden
                    : EndTimePickerStyle, shouldOnlyShowAtField: shouldOnlyShowAtField, allowOvernight: this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.Default
                    || this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule, testStartSelectId: this.props.testStartTimePickerId, testEndSelectId: this.props.testEndTimePickerId, testStartCaptionId: this.props.testStartTimePickerId, testEndCaptionId: this.props.testEndTimePickerId, testStartTimeEndTimeComponentId: this.props.testStartTimeEndTimeComponentId, type: this.props.type, minuteInterval: Recurrence_1.getStartEndTimeMinuteInterval(this.props.type, this.props.recurrenceDetails.recurrenceMinutes) }),
            this.displayDaysOfWeekPicker() && React.createElement("div", { style: isFlowRunTaskPaneType ? FlowRunPaneTypeStyles_1.FlowRunPaneDatePickerStyle : DayPickerStyle },
                React.createElement("div", { style: BentonLabelTextStyle }, Localize_1.Messages.RecurrenceCaptionOn()),
                React.createElement(WeekDayPicker_1.WeekDayPicker, { weekDays: this.weekDays, testId: this.props.testWeekDayPickerId, selectedDayIds: this.props.recurrenceDetails.recurrenceDaysOfWeek, onSelectionChanged: this.weekDaysChangedHandler, allowMultipleDaysOfWeek: this.props.type !== SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminLegacySchedule })),
            !isFlowRunTaskPaneType &&
                React.createElement("div", { style: TimeZoneStyle },
                    React.createElement(TimeZoneDisplay_1.TimeZoneDisplay, { timeZoneDetails: this.props.timeZoneDetails, label: Localize_1.Messages.RecurrenceTimeZone(), onClick: this.props.onTimeZoneClick }))));
    };
    return DailyRecurrencePane;
}(React.Component));
exports.DailyRecurrencePane = DailyRecurrencePane;
//# sourceMappingURL=DailyRecurrencePane.js.map